import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import {t} from 'i18next';
import {PrintButtonComponent} from '../report/ReportUtils';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import {Column} from 'primereact/column';
import ProjectDailyOverviewService from '../services/ProjectDailyOverviewService';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';

class ProjectDailyOverviewListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new ProjectDailyOverviewService());
        this.state = {
            list: [],
            statuses: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
        };
    }

    updateSearchCriteria(criteria) {
        return {
            projectName: criteria.projectName,
            countryName: criteria.countryName,
            startDate: criteria.startDate,
            endDate: criteria.endDate,
            statusLevel: criteria.statusLevel,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 2);
        startDate.setDate(1);
        return {
            projectName: undefined,
            countryName: undefined,
            startDate: startDate,
            endDate: null,
            statusLevel: {enumValue: "APPROVED", label: "Zaakceptowany"} ,
            sortField: 'day',
            sortAsc: true,
        };
    }

    getCriteriaName() {
        return 'project-daily-overview-list-sc';
    }

    getContainerListName() {
        return 'project-daily-overview-list-container';
    }

    renderCriteria() {
        return (
            <div className='row'>
                     <CriteriaTextComponent
                         id='projectName-sc'
                         name='projectName'
                         colClass='col-lg-4 col-sm-6'
                         value={this.state.criteria.projectName}
                         onChange={this.handleChangeSc}
                         validator={this.validator}
                         label={t('global.projectName')}
                         global={true}
                         refreshFromBackend
                         timeoutHandler={this.refreshTable}
                     />
                     <CriteriaTextComponent
                         id='countryName-sc'
                         name='countryName'
                         colClass='col-lg-4 col-sm-6'
                         value={this.state.criteria.countryName}
                         onChange={this.handleChangeSc}
                         validator={this.validator}
                         label={t('global.countryName')}
                         global={true}
                         refreshFromBackend
                         timeoutHandler={this.refreshTable}
                     />
                     <CriteriaCalendarRangeComponent
                         id='date-sc'
                         idFrom='startDate-sc'
                         idTo='endDate-sc'
                         name='date'
                         nameFrom='startDate'
                         nameTo='endDate'
                         label={'Data'}
                         colClass='col-xl-4 col-lg-8 col-sm-8'
                         from={this.state.criteria.startDate}
                         to={this.state.criteria.endDate}
                         onChange={this.handleChangeSc}
                         validator={this.validator}
                         refreshFromBackend
                         showButtonBar
                         sharedLabel
                         renderDash
                         maxDateInfinite
                         placeholderFrom={'Data od'}
                         placeholderTo={'Data do'}
                         inputsClassName='col-6'
                     />
                     <CriteriaDropdownComponent
                         id='statusLevel-sc'
                         name='statusLevel'
                         showClear
                         label={t('global.status')}
                         colClass='col-lg-4 col-sm-6'
                         value={this.state.criteria.statusLevel}
                         options={this.state.statuses}
                         placeholder='Wszystkie'
                         onChange={this.handleChangeSc}
                         validator={this.validator}
                         optionLabel='label'
                         filterOptionValue='label'
                         refreshFromBackend
                     />
                 </div>
        );
    }

    
    initializeFromBackend() {
        this.enumService
        .getEnumList('StatusLevel')
        .then((statuses) =>
            this.setState({
                statuses,
            })
        )
        .catch(() => {
            this.showErrorMessage('Nie udało się pobrać listy statusów');
        });
    }
    prepareColumns() {
        return [
            {
                field: 'day',
                header: 'Dzień',
                width: '180px',
                sortable: true,
                sortField: 'day',
            },
            {field: 'projectName', header: t('global.projectName')},
            {field: 'countryName', header: t('global.countryName')},
            {
                width:"100px",
                field: 'employees',
                header: t('projectDailyOverview.employees'),
            },
        ];
    }
    prepareHeaderItems() {
        return [
            {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                disabled: !this.state.list || this.state.list.length < 1,
                customRenderFunction: this.renderPrintButton,
            },
        ];
    }
     footerGroup() {
            const {summary} = this.state;
            return (
                
                <ColumnGroup>
                    <Row>
                        <Column footer={t('list.summary')} />
                        <Column footer='' colSpan={2} footerStyle={{textAlign: 'right'}} />
                        <Column footer={(summary.sumOfEmployees)} footerStyle={{textAlign: 'left'}} />
                        <Column />
                    </Row>
                </ColumnGroup>
            );
        }

    renderPrintButton() {
        return (
            <PrintButtonComponent
                key={`print-button-project-daily-overview-list`}
                reportFileNameBase={t('projectDailyOverview.listName')}
                xml={false}
                pdf={false}
                csv={false}
                ods={false}
                xlsx={false}
                globalFormat='xlsx'
                noMenuFlag={true}
                generateReport={this.generateReport.bind(this)}
                disabled={!this.state.list.length > 0}
            />
        );
    }
    generateReport = (format) => {
        const criteria = this.state.criteria;
        switch (format) {
            case 'xlsx':
                return this.service.exportList(criteria, 'xlsx');
            default:
                return Promise.reject('Nieznany format');
        }
    };
    afterObjectUpdate() {
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    render() {
        return (
            <div className='container-fluid project-daily-overview-list'>
                <BreadcrumbsItem to='/project-daily-overview-list'>{'Raport obciążenia projektów'}</BreadcrumbsItem>
               
                {this.renderView()}
            </div>
        );
    }
}

ProjectDailyOverviewListContainer.defaultProps = {
    lazy: true,
    renderHeader: true,
};

ProjectDailyOverviewListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    renderHeader: PropTypes.bool,
};

export default ProjectDailyOverviewListContainer;
